import { render, staticRenderFns } from "./DataFastTest.vue?vue&type=template&id=3e8857a2&scoped=true"
import script from "./DataFastTest.vue?vue&type=script&lang=js"
export * from "./DataFastTest.vue?vue&type=script&lang=js"
import style0 from "./DataFastTest.vue?vue&type=style&index=0&id=3e8857a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8857a2",
  null
  
)

export default component.exports